// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  fmtDate,
  fmtDateTime,
  getLatestAppForJob,
  applicationEligibleForTechnicalReattemptRequest,
  applicationHasReattemptHistory,
  getCoolingStatus,
  interviewStartSlotStatus,
  formatInterviewCountdown,
  INTERVIEW_SLOT_CLOSED_MESSAGE,
} from "@/legacy/helpersModule";
import { Button, Input, Reveal } from "@/shared/components/ui";
export function Jobs({ jobs, applicationHistory = [], onApply, onContinueInterview, onReattemptPortal, onTalentPool, onBack, coolingMonths, showBack = true, authCandidate = false, onTalentPoolPortal, jobBoardAuth, authStripReady = false, scheduleFlash = null }) {
  const [q, setQ] = useState("");
  const [clockTick, setClockTick] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null);
  const cm = typeof coolingMonths === "number" ? coolingMonths : 3;
  const f = jobs.filter(j => j.title.toLowerCase().includes(q.toLowerCase()) || j.location.toLowerCase().includes(q.toLowerCase()));
  const hasScheduledCountdown = authCandidate && f.some((j) => {
    const app = getLatestAppForJob(applicationHistory, j.id);
    if (!app?.interviewScheduledAt || app.interviewCompletedAt) return false;
    return interviewStartSlotStatus(app.interviewScheduledAt, false).tooEarly;
  });
  const hasPendingScheduledSlot = authCandidate && f.some((j) => {
    const app = getLatestAppForJob(applicationHistory, j.id);
    return app?.interviewScheduledAt && !app.interviewCompletedAt;
  });
  useEffect(() => {
    if (!hasScheduledCountdown && !hasPendingScheduledSlot) return undefined;
    const id = setInterval(() => setClockTick((x) => x + 1), 1000);
    return () => clearInterval(id);
  }, [hasScheduledCountdown, hasPendingScheduledSlot]);
  void clockTick;
  const getJobStatus = (j) => {
    const positionClosed = j.isOpen === false;
    let coolingDays = null;
    let showApplied = false;
    let doApply = false;
    let showContinue = false;
    let showCountdown = false;
    let countdownLabel = null;
    let showSlotClosed = false;
    let locked = false;
    let extraCoolingLine = null;
    const personal = authCandidate;
    const latestAppForJob = personal ? getLatestAppForJob(applicationHistory, j.id) : null;
    if (personal && j.userStatus === "cooling") {
      locked = true;
      coolingDays = j.coolingDaysLeft;
      const st = getCoolingStatus(applicationHistory, j.id, cm);
      if (!st.canApply && st.eligibleAt) extraCoolingLine = (<p className="text-xs text-amber-600 mt-2 font-medium">Last completed interview {fmtDate(st.lastCompletedAt || st.lastAppliedAt)}. Re-apply on {fmtDate(st.eligibleAt)} ({cm}-month cooling period).</p>);
    } else if (personal && j.userStatus === "interview_pending") {
      showContinue = true;
    } else if (personal && j.userStatus === "applied") {
      showApplied = true;
    } else if (personal && j.userStatus === "open") {
      doApply = !positionClosed;
    } else {
      const status = getCoolingStatus(applicationHistory, j.id, cm);
      if (status.pendingInterview) {
        showContinue = true;
      } else if (!status.canApply) {
        locked = true;
        coolingDays = status.daysRemaining;
        extraCoolingLine = (<p className="text-xs text-amber-600 mt-2 font-medium">Last completed interview {fmtDate(status.lastCompletedAt || status.lastAppliedAt)}. Re-apply on {fmtDate(status.eligibleAt)} ({cm}-month cooling period).</p>);
      } else if (status.hasApplied) {
        showApplied = true;
      } else {
        doApply = !positionClosed;
      }
    }
    if (personal && !locked && latestAppForJob && !latestAppForJob.interviewCompletedAt) {
      doApply = false;
      showApplied = false;
      showContinue = false;
      showCountdown = false;
      countdownLabel = null;
      showSlotClosed = false;
      const schedAt = latestAppForJob.interviewScheduledAt;
      if (schedAt) {
        const slot = interviewStartSlotStatus(schedAt, false);
        const cd = slot.tooEarly ? formatInterviewCountdown(schedAt) : null;
        if (slot.tooLate) {
          showSlotClosed = true;
        } else if (cd) {
          showCountdown = true;
          countdownLabel = cd;
        } else if (!slot.blocked) {
          showContinue = true;
        }
      } else {
        showContinue = true;
      }
    }
    const dim = locked || showApplied;
    const showReattemptPortal =
      personal &&
      typeof onReattemptPortal === "function" &&
      applicationEligibleForTechnicalReattemptRequest(latestAppForJob);
    const reattemptedNote =
      personal && latestAppForJob && applicationHasReattemptHistory(latestAppForJob);
    if (positionClosed) {
      doApply = false;
    }
    return {
      coolingDays,
      showApplied,
      doApply,
      showContinue,
      showCountdown,
      countdownLabel,
      showSlotClosed,
      locked,
      extraCoolingLine,
      latestAppForJob,
      dim,
      showReattemptPortal,
      reattemptedNote,
      positionClosed,
    };
  };
  const renderActions = (j, s, stop = true) => {
    const guard = (fn) => (e) => { if (stop) e.stopPropagation(); fn(); };
    return (
      <>
        {s.showCountdown ? (
          <button type="button" disabled className="w-full sm:w-auto px-5 py-2 bg-slate-200 text-ink-600 font-bold rounded-xl text-sm cursor-not-allowed whitespace-nowrap">Starts in {s.countdownLabel}</button>
        ) : null}
        {s.doApply ? <Button type="button" onClick={guard(() => onApply(j))} className="w-full sm:w-auto">Apply</Button> : null}
        {s.showContinue && !s.showSlotClosed ? (
          <button type="button" onClick={guard(() => onContinueInterview(j))} className="w-full sm:w-auto px-5 py-2 bg-teal-600 hover:bg-teal-500 text-white font-bold rounded-control text-sm whitespace-nowrap transition-colors">Continue interview →</button>
        ) : null}
        {s.showReattemptPortal ? (
          <Button type="button" onClick={guard(() => onReattemptPortal(j))} className="w-full sm:w-auto">Reattempt</Button>
        ) : null}
        {s.locked ? <button type="button" disabled className="w-full sm:w-auto px-5 py-2 bg-slate-100 text-ink-400 font-bold rounded-xl text-sm">Locked</button> : null}
        {s.showApplied ? <button type="button" disabled className="w-full sm:w-auto px-5 py-2 bg-slate-100 text-ink-400 font-bold rounded-xl text-sm">Applied</button> : null}
        {s.positionClosed && !s.showContinue && !s.showCountdown && !s.showReattemptPortal && !s.locked && !s.showApplied ? (
          <span className="w-full sm:w-auto px-5 py-2 bg-slate-100 text-ink-500 font-bold rounded-xl text-sm text-center whitespace-nowrap">Applications Closed</span>
        ) : null}
      </>
    );
  };
  if (selectedJob) {
    const j = jobs.find((x) => x.id === selectedJob.id) || selectedJob;
    const s = getJobStatus(j);
    return (
      <div className="min-h-dvh safe-bottom bg-surface-alt">
        <div className="bg-white border-b border-line px-4 sm:px-6 py-3 sm:py-4 safe-top safe-x flex items-center gap-3">
          <button type="button" onClick={() => setSelectedJob(null)} className="text-ink-600 hover:text-ink-900 text-sm font-semibold">← Back to all jobs</button>
        </div>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8 safe-x">
          <div className="bg-white rounded-2xl border border-line shadow-sm p-5 sm:p-7">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h1 className="text-2xl sm:text-3xl font-black text-ink-900">{j.title}</h1>
                  {s.positionClosed ? (
                    <span className="text-[10px] font-bold uppercase tracking-wide text-ink-500 bg-surface-alt border border-line px-2 py-0.5 rounded-full">
                      • Position closed
                    </span>
                  ) : null}
                </div>
                <p className="text-ink-400 mt-1">{[j.designation, j.location].filter(Boolean).join(" · ")}</p>
                {s.reattemptedNote ? <span className="inline-block mt-2 text-xs font-semibold text-brand-700">(*reattempted)</span> : null}
              </div>
              <div className="w-full sm:w-auto flex flex-col items-stretch sm:items-end gap-2 sm:shrink-0">{renderActions(j, s, false)}</div>
            </div>
            {s.latestAppForJob?.interviewScheduledAt ? (
              <p className="text-sm font-bold text-teal-700 mt-3">📅 Interview scheduled: {fmtDateTime(s.latestAppForJob.interviewScheduledAt)}</p>
            ) : null}
            {s.positionClosed && j.closedAt ? (
              <p className="text-sm font-medium text-ink-500 mt-3">Closed {fmtDate(j.closedAt)}</p>
            ) : null}
            {s.showSlotClosed ? <p className="text-sm font-semibold text-amber-800 mt-3">{INTERVIEW_SLOT_CLOSED_MESSAGE}</p> : null}
            {s.extraCoolingLine}
            {j.description ? (
              <div className="mt-6">
                <h2 className="text-sm font-black text-ink-900 uppercase tracking-wide mb-2">Job Description</h2>
                <p className="text-ink-600 text-[15px] leading-relaxed whitespace-pre-line">{j.description}</p>
              </div>
            ) : null}
            {j.requirements ? (
              <div className="mt-6">
                <h2 className="text-sm font-black text-ink-900 uppercase tracking-wide mb-2">Requirements</h2>
                <p className="text-ink-600 text-[15px] leading-relaxed whitespace-pre-line">{j.requirements}</p>
              </div>
            ) : null}
            {!j.description && !j.requirements ? (
              <p className="text-ink-400 text-sm mt-6 italic">No additional details provided for this role.</p>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-dvh safe-bottom bg-surface-alt">
      <div className="bg-white border-b border-line text-ink-900 px-4 sm:px-6 py-3 sm:py-4 safe-top safe-x flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-3">
          {showBack ? <button type="button" onClick={onBack} className="text-ink-400 hover:text-ink-900">←</button> : null}
          <span className="font-bold">Your Next Career Move Starts Here</span>
        </div>
        {/* ml-auto matters on phones: the title fills the first line, so this
            group wraps onto its own line, where justify-between would otherwise
            leave it at the LEFT edge — dragging the account menu off-screen. */}
        <div className="flex items-center gap-2 md:gap-3 flex-wrap justify-end ml-auto">
          {authStripReady && authCandidate && onTalentPoolPortal ? (
            <Button
              type="button"
              onClick={onTalentPoolPortal}
              variant="secondary"
              size="sm"
              leftIcon={<svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>}
            >
              Dashboard
            </Button>
          ) : null}
          {jobBoardAuth}
        </div>
      </div>
      <section className="relative w-full bg-white sm:bg-transparent">
        {/* Art-directed hero: the phone artwork is portrait (3:4) and the desktop
            one is wide (≈1.87:1), so they are separate images rather than one
            cropped both ways. <picture> lets the browser download only the one it
            needs. object-contain because both images carry baked-in text that
            object-cover would slice off. */}
        <picture>
          <source media="(min-width: 640px)" srcSet="/hero_image_desktop.jpg" />
          <img
            src="/hero_image_phone.jpg"
            alt="Indira IVF — Great Place To Work Certified. Find where you belong. Different roles. One shared purpose."
            /* object-contain on purpose: the artwork has baked-in text, so it is
               never cropped and a little side space is expected. Desktop cap
               raised 72vh -> 88vh to scale it up without going full-bleed. */
            className="w-full h-auto max-h-[55vh] sm:max-h-[88vh] object-contain object-center"
          />
        </picture>
        <img
          src="/great-place-to-work.png"
          alt="Indira IVF — Great Place To Work Certified, Jan 2026–Jan 2027, India"
          className="absolute top-2 right-2 sm:top-4 sm:right-4 w-9 sm:w-14 md:w-20 h-auto z-10 drop-shadow-md"
          loading="lazy"
        />
        <a
          href="#openings"
          className="absolute bottom-3 sm:bottom-5 left-1/2 -translate-x-1/2 inline-flex flex-col items-center gap-1 text-brand-red font-bold text-xs md:text-sm uppercase tracking-wide"
        >
          View Open Roles
          <span aria-hidden className="text-3xl animate-bounce">↓</span>
        </a>
      </section>
      <div id="openings" className="w-full px-4 sm:px-6 md:px-10 py-6 sm:py-8 scroll-mt-4 safe-x">
        {/* px-5 / sm:px-6 mirrors the job cards' own p-5 / sm:p-6, so the title
            and strapline line up with the card text ("Consultant Gynecologist")
            instead of sitting flush against the container edge. */}
        <h1 className="px-5 sm:px-6 text-xl sm:text-3xl font-black text-ink-900 mb-2">Join the Team Behind Thousands of Parenthood Journeys</h1>
        <p className="px-5 sm:px-6 text-sm sm:text-base text-ink-400 mb-4 sm:mb-5">Indira IVF — India's Leading Fertility Healthcare Chain</p>
        <Input value={q} onChange={e => setQ(e.target.value)} placeholder="Search jobs…" className="mb-4 shadow-sm"/>
        {onTalentPool ? (
          <div className="bg-gradient-to-r from-brand-50 to-brand-50 border border-brand-200 rounded-2xl p-5 mb-5 flex items-center justify-between flex-wrap gap-3">
            <div><p className="font-bold text-brand-900 mb-0.5">☀ Stay Connected</p><p className="text-sm font-semibold text-brand-700">Don't see the right opportunity today?</p><p className="text-xs text-brand-600">Join our Talent Community and we'll reach out when a role matches your experience and aspirations.</p></div>
            <Button type="button" onClick={onTalentPool} className="shrink-0">Join Talent Pool →</Button>
          </div>
        ) : null}
        <div className="space-y-4">{f.map((j, i) => {
          const s = getJobStatus(j);
          return (
            <Reveal key={j.id} delay={Math.min(i * 60, 300)}>
            <div onClick={() => setSelectedJob(j)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter") setSelectedJob(j); }} className={`bg-white rounded-2xl border p-5 sm:p-6 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 cursor-pointer transition-shadow ${s.positionClosed ? "border-line opacity-75 bg-surface-alt/30 hover:shadow-md" : s.dim ? "border-line opacity-75 hover:shadow-md" : "border-line hover:shadow-lg hover:border-brand-200"}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h2 className="text-xl font-bold text-ink-900">{j.title}</h2>
                  {s.positionClosed ? (
                    <span className="text-[10px] font-bold uppercase tracking-wide text-ink-500 bg-white border border-line px-2 py-0.5 rounded-full">
                      • Position closed
                    </span>
                  ) : null}
                  {s.locked && s.coolingDays != null ? <span className="text-xs font-bold text-amber-700 bg-amber-50 border border-amber-200 px-2 py-0.5 rounded-full">Cooling: {s.coolingDays}d left</span> : null}
                  {s.reattemptedNote ? <span className="text-xs font-semibold text-brand-700">(*reattempted)</span> : null}
                </div>
                <p className="text-ink-400 text-sm">{j.designation} · {j.location}</p>
                <p className="text-ink-600 text-sm mt-2 line-clamp-2">{j.description}</p>
                <p className="text-brand-600 text-xs font-bold mt-2">View details →</p>
                {s.positionClosed && j.closedAt ? (
                  <p className="text-xs font-medium text-ink-400 mt-2">Closed {fmtDate(j.closedAt)}</p>
                ) : null}
                {s.latestAppForJob?.interviewScheduledAt ? (
                  <p className="text-xs font-bold text-teal-700 mt-2">📅 Interview scheduled: {fmtDateTime(s.latestAppForJob.interviewScheduledAt)}</p>
                ) : null}
                {scheduleFlash && scheduleFlash.jobId === j.id && scheduleFlash.rescheduled ? (
                  <p className="text-xs font-semibold text-brand-700 mt-1">* Rescheduled to {fmtDateTime(scheduleFlash.at)}</p>
                ) : null}
                {s.showSlotClosed ? (
                  <p className="text-xs font-semibold text-amber-800 mt-2">{INTERVIEW_SLOT_CLOSED_MESSAGE}</p>
                ) : null}
                {s.extraCoolingLine}
              </div>
              <div className="w-full sm:w-auto sm:shrink-0 flex flex-col items-stretch sm:items-end gap-2">
                {s.showSlotClosed ? (
                  <p className="sm:px-4 py-2 w-full sm:max-w-[14rem] text-left sm:text-right text-xs font-semibold text-amber-800 leading-snug">{INTERVIEW_SLOT_CLOSED_MESSAGE}</p>
                ) : null}
                {renderActions(j, s, true)}
              </div>
            </div>
            </Reveal>
          );
        })}{f.length === 0 ? <p className="text-center text-ink-400 py-12">No matching jobs.</p> : null}</div>
      </div>
    </div>
  );
}

